import React from "react";
import classNames from "classnames";

export default function Icon({
  name,
  spin,
  prefix,
  className = "",
  style = {},
}: {
  name: string;
  spin?: boolean;
  prefix?: string;
  className?: string;
  style?: object;
}) {
  return (
    <i
      aria-hidden="true"
      className={classNames(
        `${prefix ? prefix : "fa"}`,
        `fa-${name}`,
        { "fa-spin": !!spin },
        className
      )}
      style={style}
    />
  );
}
